<div class="page-content">
    <div class="page-header">
        <h1>
            @if(project && project.code){ 
                {{project.code}} : {{project.label}}
            }
            @else{
                Projet
            }</h1>
        <div class="page-description">Mettre à jour les informations du projet</div>
    </div>

    <div class="page-body" *ngIf="project && project.id">
            <div class="modal-content-body" [formGroup]="projectFormGroup">
                <div class="form-row">
                    
                    <div class="half-width">
                        <label for="email" class="required">Code</label>
                        <ed-textfield
                            innerId="code"
                            name="code"
                            type="code"
                            placeholder="2026001"
                            [required]="true"
                            [formControlName]="'code'"></ed-textfield>
                    </div>
                </div>
                <div class="form-row">
                    <div class="half-width">
                        <label for="firstname" class="required">Label</label>
                        <ed-textfield
                            innerId="Label"
                            name="Label"
                            type="text"
                            placeholder="Client - Mission"
                            [required]="true"
                            [formControlName]="'label'"></ed-textfield>
                    </div>
                </div>
                <div class="form-row">
                    <div class="half-width">
                        <label for="soldAmount" class="required">Montant total</label>
                        <ed-numberfield
                            innerId="soldAmount"
                            name="soldAmount"
                            type="number"
                            placeholder="100 000"
                            [required]="true"
                            unit="€ HT"
                            [formControlName]="'soldAmount'"></ed-numberfield>
                    </div>
                    <div class="half-width">
                        <label for="subcontractingAmount">Montant sous-traitance</label>
                        <ed-numberfield
                            innerId="subcontractingAmount"
                            name="subcontractingAmount"
                            type="number"
                            placeholder="0"
                            [required]="false"
                            unit="€ HT"
                            [formControlName]="'subcontractingAmount'"></ed-numberfield>
                    </div>
                    <div class="half-width">
                        <label for="soldDayRate" >Tarif journalier</label>
                        <ed-numberfield
                            innerId="soldDayRate"
                            name="soldDayRate"
                            type="number"
                            placeholder="850"
                            [required]="false"
                            unit="€ HT"
                            [formControlName]="'soldDayRate'"></ed-numberfield>
                    </div>
                </div>
                <div class="form-row">  
                    <div class="half-width">
                        <label for="activityId" class="required">Statut</label>
                        <ed-select
                        id="status"
                        placeholder="Statut"
                        [formControlName]="'status'"
                        [required]="true"
                        [options]="statusList">
                        </ed-select>  
                    </div>
                     <div class="half-width">
                        <label for="estimatedCloseDate">Date de cloture estimée</label>
                        <ed-datepicker
                        id="estimatedCloseDate"
                        [required]="false"
                        [formControlName]="'estimatedCloseDate'"
                        >
                        </ed-datepicker>  
                    </div>
                </div>
                
                <div class="form-row">  
                   <div class="half-width">
                        <label for="activityId" class="required">Activité</label>
                        <ed-select
                        id="activityId"
                        placeholder="Activité"
                        [formControlName]="'activityId'"
                        [required]="true"
                        [options]="activityList">
                        </ed-select>  
                    </div>
                    <div class="half-width">
                        <label for="leadUserId" class="required">Chef.fe de projet</label>
                        <ed-search
                        id="leadUserId"
                        placeholder="Séléctionnez un chef de projet"
                        [formControlName]="'leadUserId'"
                        [isMulti]="false"
                        [required]="false"
                        [options]="leadUserOptions()">
                        </ed-search>  
                    </div>
                </div>
            </div>
            

            <div class="layer-actions">
                <ed-button [colorSchema]="buttonColors.Secondary" (click)="close()">Retour</ed-button>
                <ed-button (click)="valid()" [disabled]="canCreateEdit()">Mettre à jour</ed-button>
            </div>
    </div>
</div>